<template>
  <!-- 面包屑 -->
  <el-row class="breadcrumbBox" type="flex" justify="space-between">
    <el-col><el-breadcrumb v-if="isShow" separator="/">
        <transition-group name="breadcrumb">
          <el-breadcrumb-item v-for="(item, index) in getNavList" :key="item.path">
            <span :class="{ isActive: index === getNavList.length - 1 }">{{
              item.title
            }}</span>
          </el-breadcrumb-item>
        </transition-group>
      </el-breadcrumb></el-col>
    <el-button v-if="isShowGoBack" icon="iconfont pro-icon-fanhui" type="text" @click="goBack">返回</el-button>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      leveList: [],
      isShow: false, //当前是否显示
      isShowGoBack: false, //当前是否显示返回列表
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  mounted() {
    this.getBreadcrumb();
  },
  computed: {
    getNavList() {
      return this.$store.state.websetting.navBreadList;
    },
  },
  methods: {
    getBreadcrumb() {
      let list = [];
      this.$route.matched.filter((item) => {
        if (item.path) {
          list.push({
            title: item.meta.title,
            path: item.path,
          });
        }
        this.isShow = item.meta.isBavBread ? true : false;
        this.isShowGoBack = item.meta.isShowGoBack ? true : false;
      });
      if (Array.isArray(this.$store.state.websetting.navBreadList) && this.$store.state.websetting.navBreadList.length > 2 && this.$store.state.websetting.navBreadList[2].path == this.$route.path) {
      } else {
        this.$store.commit("setNav", list);
      }
    },
    goBack() {
      if (this.$route.meta.parentsName == 'theoryInfo') {
        this.$router.go(-1)
      } else {
        this.$router.push({
          name: this.$route.meta.parentsName
            ? this.$route.meta.parentsName
            : "admin",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.breadcrumbBox {
  border-bottom: 1px solid #dcdfe6;

  .el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 8px;

    .no-redirect {
      color: #97a8be;
      cursor: text;
    }

    .isActive {
      color: #409eff;
    }

    .el-breadcrumb__item {
      line-height: 40px;
    }
  }
}
</style>
